import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// redux
import { connect } from 'react-redux';
// lodash
import get from 'lodash/get';
// classnames
import classNames from 'classnames';
// utils
import { isZeroAmount } from '../../utils';
// components
import styles from './order-totals.scss';

export class OrderTotals extends PureComponent {

  static propTypes = {
    amounts: PropTypes.shape({
      basketTotal: PropTypes.string,
      deliveryCharge: PropTypes.string,
      grandTotal: PropTypes.string,
      outstandingBalance: PropTypes.string,
      partnerDiscountTotal: PropTypes.string,
      paymentTotals: PropTypes.shape({
        giftCard: PropTypes.string,
        giftVoucher: PropTypes.string,
      }),
      subtotal: PropTypes.string,
    }),
    confirmationPage: PropTypes.bool,
    isClickCollectOrder: PropTypes.bool,
    isDeliveryPage: PropTypes.bool,
    isGiftReceiptOrder: PropTypes.bool,
    promotionalCode: PropTypes.shape({}),
    sidebarView: PropTypes.bool,
    streamlinedPayments: PropTypes.bool,
  };

  static defaultProps = {
    amounts: {
      deliveryCharge: '',
      paymentTotals: {},
    },
    confirmationPage: false,
    deliveryCharge: '',
    isClickCollectOrder: false,
    isDeliveryPage: false,
    isGiftReceiptOrder: false,
    promotionalCode: {},
    sidebarView: false,
    streamlinedPayments: false,
  };

  getContainerClassnames = () => {
    const { isDeliveryPage, sidebarView, streamlinedPayments } = this.props;

    return classNames(styles.container, {
      [styles.isDeliveryPage]: isDeliveryPage,
      [styles.sidebar]: sidebarView,
      [styles.streamlinePaymentsView]: streamlinedPayments,
    });
  };

  render() {
    const {
      amounts,
      confirmationPage,
      isClickCollectOrder,
      isDeliveryPage,
      isGiftReceiptOrder,
      promotionalCode,
      sidebarView,
      streamlinedPayments,
    } = this.props;

    const {
      deliveryCharge,
      grandTotal,
      basketTotal,
      outstandingBalance,
      partnerDiscountTotal,
      paymentTotals: {
        giftCard,
        giftVoucher,
      } = {},
    } = amounts;

    const promoCodeRemoved = get(promotionalCode, 'isRemoved', false);
    const promotionalCodeAmount = get(promotionalCode, 'amount');

    const showGiftCard = !confirmationPage && !isZeroAmount(giftCard);
    const showGiftVoucher = !confirmationPage && !isZeroAmount(giftVoucher);
    const orderTotalLabel = confirmationPage ? 'Total paid:' : 'Order total';
    const orderTotalValue = confirmationPage ? grandTotal : outstandingBalance;
    const showPromotionalCodeAmount = !promoCodeRemoved && !isZeroAmount(promotionalCodeAmount);

    const deliveryChargeText = isClickCollectOrder ? 'Collection charge' : 'Delivery charge';

    const giftMessageInfoClassnames = classNames(styles.giftMessagePricesInfo, {
      [styles.sidebar]: sidebarView,
    });

    return (
      <div className={this.getContainerClassnames()} data-test="order-totals-container">

        {
          !sidebarView &&
          streamlinedPayments &&
          partnerDiscountTotal &&
          <div data-test="order-totals-partner-discount-total">
            <span>Partner discount</span>
            <span>-{partnerDiscountTotal}</span>
          </div>
        }

        <div data-test="order-totals-basket-total">
          <span>Basket total</span>
          <span className={styles.basketTotals}>
            {basketTotal}
          </span>
        </div>

        {
          isDeliveryPage &&
          <div data-test="order-totals-delivery-charge-info">
            <span>(Excluding delivery charge)</span>
          </div>
        }

        {
          !isDeliveryPage &&
          <div data-test="order-totals-delivery">
            <span>{deliveryChargeText}</span>
            <span>{deliveryCharge}</span>
          </div>
        }
        {
          showPromotionalCodeAmount &&
          <div data-test="order-totals-promotional-code">
            <span>Promo code</span>
            <span>-{promotionalCodeAmount}</span>
          </div>
        }
        {
          !isDeliveryPage && (showGiftCard || showGiftVoucher) &&
          <div data-test="order-totals-subtotal">
            <span>Total</span>
            <span>{grandTotal}</span>
          </div>
        }
        {
          showGiftCard &&
          <div data-test="order-totals-gift-card">
            <span>Gift cards applied</span>
            <span>-{giftCard}</span>
          </div>
        }
        {
          showGiftVoucher &&
          <div data-test="order-totals-gift-voucher">
            <span>Gift vouchers applied</span>
            <span>-{giftVoucher}</span>
          </div>
        }
        {
          !isDeliveryPage &&
          <div className={styles.outstandingBalance} data-test="order-totals-balance">
            <span className={styles.outstandingBalanceLabel}>{orderTotalLabel}</span>
            <span>{orderTotalValue}</span>
          </div>
        }
        {
          isGiftReceiptOrder &&
          <p
            className={giftMessageInfoClassnames}
            data-test="gift-message-prices-info"
          >
            Prices will not be shown on the gift receipt
          </p>
        }
      </div>
    );
  }
}

export function mapStateToProps(state) {
  return {
    amounts: state.orderForm.amounts,
    isGiftReceiptOrder: state.orderForm.isGiftReceiptOrder,
    isClickCollectOrder: state.orderForm.isClickCollectOrder,
    promotionalCode: state.orderForm.promoCodeApplied,
    partnerDiscountEnabled: state.user.partnerDiscountEnabled,
  };
}

export default connect(state => mapStateToProps(state))(OrderTotals);
